import { useNavigate } from 'react-router-dom'
import logo from '../../assets/newlogo.png'

const Header = () => {
  const navigate=useNavigate()
  return (
    <nav className="w-full bg-white shadow-sm px-4 py-3 sticky top-0 z-50">
      <div className="p-4 flex items-center gap-4 w-full">
        <div className="cursor-pointer" onClick={()=>navigate(-1)}>
          <img
            src={logo}
            className="w-full h-12  object-contain cursor-pointer"
            alt="Logo"
                        

          />
        </div>
      </div>
    </nav>
  )
}

export default Header
